import styled from 'styled-components';

import { Button } from '@/shared/components/ui/button/button';

export const AppVersionRefreshBadgeButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.palette.status.yellow.text};
    background-color: ${({ theme }) => theme.palette.status.yellow.background};
    box-shadow: inset 0 0 0 1px
      ${({ theme }) => theme.palette.status.yellow.stroke};
    height: 3.25rem;

    svg {
      color: ${({ theme }) => theme.palette.status.yellow.text};
    }

    &:hover {
      background-color: ${({ theme }) =>
        theme.palette.status.yellow.background};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.status.yellow.stroke};
    }
  }
`;

export const AppVersionRefreshBadgeLabel = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
  text-align: left;
  gap: 0.25rem;
`;
